import React from 'react'
import './Attribution.css'

export default function Attribution () {
    return (
        <footer className='attribution'>
            <p>Created by Liron de Castro for her final capstone at <a href='https://www.thinkful.com/'>Thinkful</a>.</p>
            <a href='https://www.linkedin.com/in/liron-de-castro/' className='separate_link'>LinkedIn</a>
            <a href='https://github.com/lirondco' className='separate_link'>GitHub</a>
            <p>Tel Aviv, Israel x San Diego, CA</p>
            <p lang='zh-Hant'>人民有顛覆暴政的自由</p>
        </footer>
    )
}